export const boardCharterTour = {
  key: "boardCharter",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-charter-scope"]',
      content: t("Tour_Charter_Personas"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-charter-stakeholders"]',
      content: t("Tour_Charter_Epics"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-charter-risks"]',
      content: t("Tour_Charter_Goals"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-charter-times"]',
      content: t("Tour_Charter_DODs"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-charter-limitations"]',
      content: t("Tour_Charter_Limitations"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-charter-riskstab"]',
      content: t("Tour_Charter_Risks"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-charter-budget"]',
      content: t("Tour_Charter_Budget"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-charter-timestab"]',
      content: t("Tour_Charter_Times"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-charter-rules"]',
      content: t("Tour_Charter_Rules"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-charter-beneficiaries"]',
      content: t("Tour_Charter_Beneficiaries"),
      placement: "bottom",
    },
  ],
};
